import type { ChemDokuPack, ChemDokuSize } from "./engine";

/**
 * Symbol packs for Chem-doku. Each pack groups elements that share a
 * concept the player should associate together (noble gases, halogens,
 * period-2 nonmetals, etc.) so playing the puzzle reinforces real
 * chemistry, not just symbol-matching.
 *
 * `symbols.length` must equal the size it's listed under in `PACKS`.
 */

export const PACKS_4: ChemDokuPack[] = [
  {
    id: "halogens-4",
    label: "Halogens (4)",
    description: "Group 17: F, Cl, Br, I.",
    symbols: ["F", "Cl", "Br", "I"],
  },
  {
    id: "alkali-4",
    label: "Alkali metals (4)",
    description: "Group 1 (skipping H): Li, Na, K, Rb.",
    symbols: ["Li", "Na", "K", "Rb"],
  },
  {
    id: "noble-4",
    label: "Noble gases (4)",
    description: "He, Ne, Ar, Kr.",
    symbols: ["He", "Ne", "Ar", "Kr"],
  },
  {
    id: "diatomic-4",
    label: "Diatomic gases (4)",
    description: "Pure gases that pair up: H, N, O, F.",
    symbols: ["H", "N", "O", "F"],
  },
];

export const PACKS_6: ChemDokuPack[] = [
  {
    id: "period2-6",
    label: "Period 2 (6)",
    description: "Six light-atom workhorses: C, N, O, F, Ne, B.",
    symbols: ["B", "C", "N", "O", "F", "Ne"],
  },
  {
    id: "noble-6",
    label: "Noble gases (6)",
    description: "All six: He, Ne, Ar, Kr, Xe, Rn.",
    symbols: ["He", "Ne", "Ar", "Kr", "Xe", "Rn"],
  },
  {
    id: "coinage-6",
    label: "Common metals (6)",
    description: "Cu, Ag, Au, Fe, Zn, Pb.",
    symbols: ["Cu", "Ag", "Au", "Fe", "Zn", "Pb"],
  },
  {
    id: "alkali-6",
    label: "Alkali + alkaline (6)",
    description: "Li, Na, K, Mg, Ca, Ba.",
    symbols: ["Li", "Na", "K", "Mg", "Ca", "Ba"],
  },
];

export const PACKS: Record<ChemDokuSize, ChemDokuPack[]> = {
  4: PACKS_4,
  6: PACKS_6,
};